import { render, staticRenderFns } from "./xgt.vue?vue&type=template&id=10415db1&scoped=true&"
import script from "./xgt.vue?vue&type=script&lang=js&"
export * from "./xgt.vue?vue&type=script&lang=js&"
import style0 from "./xgt.vue?vue&type=style&index=0&id=10415db1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10415db1",
  null
  
)

export default component.exports